import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'dead-message-list',
        label: 'Dead Letters',
        to: '/tech-ops/dead-message',
      }),
    }) satisfies AggregateBreadcrumb,
});
